@if (app.showMaintenanceWarning() && !app.isMaintenance()) {
  <mat-card class="login-card mat-card-standalone" style="margin-bottom:-7.5%;">
    <mat-card-content>
      <mat-card-header>
        <mat-card-title class="mat-card-title">ANNOUNCEMENT</mat-card-title>
        <mat-card-subtitle [innerHTML]="app.getMaintenanceWarning()" />
      </mat-card-header>
    </mat-card-content>
  </mat-card>
}

<mat-card class="login-card mat-card-standalone">
  @if (app.isMaintenance()) {
    <mat-card-header>
      <mat-card-title>GAMS is unavailable now</mat-card-title>
      <mat-card-subtitle>Please try again later. Maintenance window is {{ app.getMaintenanceWindow() }}</mat-card-subtitle>
    </mat-card-header>
  }


  @if (!app.isMaintenance()) {
    <mat-card-content>
      <form class="login-form">
        <table class="full-width" cellspacing="0">
          <tr>
            <td align="center">
              <p class="mat-card-title">Login</p>
            </td>
          </tr>
          <tr>
            <td align="center">
              <i class="material-icons md-64">account_circle</i>
            </td>
          </tr>
          <tr>
            <td align="center">
              <p class="error-msg">{{errorMsg}}</p>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field class="full-width">
                <mat-label>Username</mat-label>
                <input matInput [(ngModel)]="login" name="login" required>
                <mat-icon matPrefix>person</mat-icon>
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field class="full-width">
                <mat-icon matPrefix>lock</mat-icon>
                <mat-label>Password</mat-label>
                <input matInput class="passwd-input" [(ngModel)]="passwd" [type]="showPassword ? 'text' : 'password'" (keyup.enter)="userLogIn()" name="passwd" required>
                <mat-icon (mousedown)="mouseDown()" (mouseup)="mouseUp()" class="eye-btn" matSuffix>visibility</mat-icon>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </form>
      <!--   <mat-spinner [style.display]="showSpinner ? 'block' : 'none'"></mat-spinner> -->
    </mat-card-content>
  }
  @if (!app.isMaintenance()) {
    <mat-card-actions>
      <button mat-raised-button (click)="userLogIn()" color="primary" class="full-width">Login</button>
    </mat-card-actions>
  }
  @if (!app.isMaintenance()) {
    <mat-card-footer>
      <button mat-stroked-button (click)="forgotPassword()">Forgot password?</button>
    </mat-card-footer>
  }
</mat-card>
